import React from "react";
import { Accordion } from "@folio/stripes/components";
import { useIntl } from "react-intl";
import { RecekSelect } from "./inputs";
import { PROPOSAL_ORIGIN_IMPORT, PROPOSAL_ORIGIN_PUBLISHER, } from "../utils/personProposalOrigin";
/**
 * "Původ návrhu" register filter of natural and legal persons: all persons,
 * only those proposed by a publisher, or only the import placeholders from the
 * publication records, so the new publisher proposals can be processed first
 * (DB-899). The help text (`.help` translation) explains both origins.
 */
export var PersonProposalOriginFilter = function (_a) {
    var value = _a.value, onChange = _a.onChange;
    var formatMessage = useIntl().formatMessage;
    return (React.createElement(Accordion, { label: formatMessage({
            id: "ui-br-agency.person.filter.proposalOrigin",
        }), separator: false },
        React.createElement(RecekSelect, { labelId: "ui-br-agency.person.filter.proposalOrigin", showLabel: false, value: value, onChange: function (event) {
                return onChange(event.target.value);
            }, fullWidth: true },
            React.createElement("option", { value: "" }, formatMessage({
                id: "ui-br-agency.collectionsList.select.option.all",
            })),
            React.createElement("option", { value: PROPOSAL_ORIGIN_PUBLISHER }, formatMessage({
                id: "ui-br-agency.person.filter.proposalOrigin.publisher",
            })),
            React.createElement("option", { value: PROPOSAL_ORIGIN_IMPORT }, formatMessage({
                id: "ui-br-agency.person.filter.proposalOrigin.import",
            })))));
};
